export default "__VITE_ASSET__DQviGquL__"